import { Box, BoxProps } from "@primer/react";
import { useEffect } from "react";

interface IPageLayoutProps extends BoxProps {
    title?: string;
    /** Width content area. Default 1280px. */
    maxWidth?: number | string;
    children: React.ReactNode;
}

/**
 * Container chuẩn cho trang authenticated — center content, padding đồng nhất, set document.title.
 * Pattern theo ESS_TKB_Web `<Page title="...">`.
 */
const PageLayout = ({ title, maxWidth = 1280, children, sx, ...rest }: IPageLayoutProps) => {
    useEffect(() => {
        if (title) document.title = `${title} — Cổng đăng ký tín chỉ`;
    }, [title]);

    return (
        <Box
            as="main"
            sx={{
                maxWidth,
                mx: "auto",
                px: [3, 3, 4],
                py: [3, 4],
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Box>
    );
};

export default PageLayout;
